module.exports = __webpack_public_path__ + "static/media/hongtoushan4.5cc340fe.jpg";